export const progressStepTitlesDefault = [
  'Personalize',
  'Address',
  'Schedule',
  'Review'
];

export const progressStepTitlesGiftCard = [
  'Personalize',
  'Address',
  'Schedule',
  'Gift Card',
  'Review'
];

export const progressStepStates = {
  disabled: 'disabled',
  active: 'active',
  completed: 'completed'
};
